import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";

const CRMGmailIntegration = ({ email }) => {
    
    const [isIntegrated, setIsIntegrated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingAction, setPendingAction] = useState(null); // "on" | "off"

    

    const checkIntegration = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("email", email);

            const response = await fetch(
                process.env.REACT_APP_CRM + "/gmail/check?" + params.toString()
            );

            const result = await response.json();

            if (result && result.status === true) {
                setIsIntegrated(true);
            } else {
                setIsIntegrated(false);
            }
        } catch (err) {
            console.error("Error checking Gmail integration:", err);
            setIsIntegrated(false);
        } finally {
            setLoading(false);
        }
    };

    const enableIntegration = () => {
        window.open(
            process.env.REACT_APP_CRM +
                "/gmail/crm/auth?email=" +
                encodeURIComponent(email),
            "_blank"
        );
    };

    const disableIntegration = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("email", email);
            params.append("remove", "true");

            const response = await fetch(
                process.env.REACT_APP_CRM + "/gmail/check?" + params.toString()
            );

            const result = await response.json();

            if (
                result &&
                result.status === true &&
                result.has_removed === true
            ) {
                setIsIntegrated(false);
            }
        } catch (err) {
            console.error("Error removing Gmail integration:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleToggleClick = () => {
        if (isIntegrated === false) {
            setPendingAction("on");
        } else {
            setPendingAction("off");
        }
        setShowConfirmModal(true);
    };

    const confirmAction = () => {
        if (pendingAction === "on") {
            enableIntegration();
        } else if (pendingAction === "off") {
            disableIntegration();
        }
        setShowConfirmModal(false);
        setPendingAction(null);
    };

    useEffect(() => {
        if (email) {
            checkIntegration();
        }
    }, [email]);

    useEffect(() => {
        const handleMessage = (event) => {
            if (
                event &&
                event.data &&
                event.data.type === "GMAIL_INTEGRATION_SUCCESS"
            ) {
                setIsIntegrated(true);
                // optional safety re-check
                checkIntegration();
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    return (
        <div className="title emps_mob mt-3">
            
            {loading ? (
                <p>Loading...</p>
            ) : (
                <div className="ai-toggle d-flex align-items-center me-4 mt-2">
                    <span className="toggle-label ml-2">
                        Allow the CRM to read your emails
                    </span>
                    <label className="switch m-0">
                        <input
                            type="checkbox"
                            checked={isIntegrated}
                            onChange={handleToggleClick}
                        />
                        <span className="slider round"></span>
                    </label>
                </div>
            )}

            <ReactModal
                isOpen={showConfirmModal}
                onRequestClose={() => setShowConfirmModal(false)}
                className="styled-modal"
                overlayClassName="styled-modal-overlay"
                ariaHideApp={false}
            >
                <div className="p-4">
                    <h5 className="fw-semibold mb-3">
                        {pendingAction === "on"
                            ? "Enable Gmail Integration"
                            : "Disable Gmail Integration"}
                    </h5>

                    <p className="text-muted mb-4">
                        {pendingAction === "on" ? (
                            <div>
                                This feature allows the CRM application to read customer-related
                                emails and automatically log sent and received emails as notes
                                against CRM leads.
                                <br /><br />
                                This feature is intended for customer-facing employees only.
                                You will be redirected to Gmail to authorize access.
                            </div>
                        ) : (
                            <div>
                                Are you sure you want to disable Gmail integration?
                                <br /><br />
                                This will stop the CRM from accessing your Gmail account and
                                prevent sent and received emails from being logged as notes
                                against CRM leads.
                                <br /><br />
                                Existing email activity already logged in the CRM will remain
                                unchanged.
                            </div>
                        )}
                    </p>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                        }}
                    >
                        <button
                            className="btn btn-outline-secondary"
                            onClick={() => setShowConfirmModal(false)}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={confirmAction}
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
};

export default CRMGmailIntegration;



// WEBPACK FOOTER //
// ./src/components/hrAdmin/CRMGmailIntegration.js